import { Component } from '@angular/core';

@Component({
    selector: 'app-dashboard',
    imports: [],
    template: ``
})
export class Dashboard {}
